<footer>

  
      
    
      
  <section class="bottom-footer">
    <div class="container" *ngIf="loginType=='B2C'">
      <div class="firstrow">
        <div class="socialmedia">
          <h2>Follow us</h2>
          <ul>
            <li> <a href="#" target="_blank"> <span class="ak-facebook"></span> </a> </li>
            <li> <a href="#" target="_blank"> <span class="ak-twitter "></span> </a> </li>
            <li> <a href="#" target="_blank"> <span class="ak-instagram"></span> </a> </li>
          </ul>
        </div>
        <div class="rightsection">
          <div class="squareouter">
            <div class="row-one">
              <div class="imgouter">
                <h6>We Accept</h6>
              </div>
              <div class="imgouter">
                <div class="visacard img"></div>
              </div>
              <div class="imgouter">
                <div class="mastercard img"></div>
              </div>
              <div class="imgouter" f>
                <div class="dinersclub img"></div>
              </div>
              <div class="imgouter">
                <div class="amex img"></div>
              </div>
              <div class="imgouter">
                <div class="rupay img"></div>
              </div>
            </div>
            <div class="row-one">
              <div class="imgouter">
                <h6>Member of</h6>
              </div>
              <div class="imgouter">
                <div class="incradibleindia img"></div>
              </div>
              <div class="imgouter">
                <div class="iata img"></div>
              </div>
              <div class="imgouter">
                <div class="tafi img"></div>
              </div>
              <div class="imgouter">
                <div class="maharashtrature img"></div>
              </div>
            </div>
          </div>
          <div class="certified-block">
            <h3>Certified By</h3>
            <a href="https://sealserver.trustkeeper.net/compliance/cert.php?code=x4ix8flmFVRIQRKlPlfZ1Nc3X2IC2k"
              target="_blank">
              <div class="trustwave img"></div>
            </a>
          </div>
          <div class="powered-block">
            <h3>Powered By</h3>
            <a r href="http://www.benzyinfotech.com/" target="_blank">
              <div class="benzy img"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <p>Copyright © 2020 <a target="_blank" href="https://www.akbartravels.com/">www.akbartravels.com</a> All Rights
      Reserved. </p>
  </section>
</footer>